import {convertMeasurementDataUnits} from "../views/dashboard/charts/check-in-history/measurement-utils"

export const ACTION_TYPES = {
  SET: "measurements/SET",
  LOAD: "measurements/LOAD",
  SET_MEASUREMENT_DATA: "measurements/SET_MEASUREMENT_DATA",
  TIP: "measurements/TIP",
};

const initialState = {
  show: false,
  isCheckin: false,
  tip: "",
  anchor: "",
  unit: 1,
  currentReportDate: "",
  prevMeasurementsData: {
  },
  measurementsData: {
  },
  checkinMeasurementsData: {
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.SET:
      if("unit" in action.payload) {
        const newMeasurementsData = convertMeasurementDataUnits({...state.measurementsData}, state.unit, action.payload.unit)
        const newPrevMeasurementsData = convertMeasurementDataUnits({...state.prevMeasurementsData}, state.unit, action.payload.unit)
        return { ...state, ...action.payload, measurementsData: newMeasurementsData, prevMeasurementsData: newPrevMeasurementsData };
      } else {
        return { ...state, ...action.payload };
      }
    case ACTION_TYPES.LOAD:
      return { ...state, ...action.payload };
    case ACTION_TYPES.SET_MEASUREMENT_DATA:
      const { key, val } = action.payload;
      let newMeasurementsData = { ...state.measurementsData };
      if (!val && key in newMeasurementsData) {
        delete newMeasurementsData[key];
      } else {
        if (Number(val) <= 999) {
          newMeasurementsData[key] = val;
        }
      }
      return { ...state, measurementsData: newMeasurementsData };
    case ACTION_TYPES.TIP:
      return {
        ...state,
        tip: action.payload.tip,
        anchor: action.payload.anchor,
      };
    default:
      return state;
  }
};
